<mat-list-item [ngClass]="classItem()">
  @if (tooltip() != null) {
    <label matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()"
      [matTooltip]="tooltip()" [class.warn]="checkRequired() || checkValid()">
      <span>{{label()}}</span>
    </label>
  }
  @if (tooltip() == null) {
    <label [class.warn]="checkRequired() || checkValid()">{{label()}}</label>
  }
  <ng-container>
    <unite-input-field [control]="control()" [type]="type()" [max]="max()" [negative]="negative()" [editIcon]="editIcon()" [suffix]="suffix()" [pattern]="pattern()" classField="inline-field"></unite-input-field>
  </ng-container>
</mat-list-item>